exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ux-dialog-container>div {\r\n    margin-top: 30px!important;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    ux-dialog-container>div {\r\n        width: 80%!important;\r\n        margin-left: 10%!important;\r\n    }\r\n}\r\n\r\n@media (min-width: 1025px) {\r\n    ux-dialog-container>div {\r\n        width: 60%!important;\r\n        margin-left: 20%!important;\r\n    }\r\n}", ""]);

// exports
